import React from "react";
import { Outlet } from "react-router-dom";

const OverviewLayout = () => {
  return (
    <>
      <main>
        <Outlet />
      </main>
    </>
  );
};

export default OverviewLayout;
